export const API_TRAVEL_INIT = '/api/travel/init'
export const API_TRAVEL_APARTMENT_INIT = '/api/travel/init-apartment'
export const API_TRAVEL_DESTINATIONS = '/api/travel/destinations'
export const PAGE_SEARCH = '/wycieczki';
export const PAGE_SEARCH_CHARTERS = '/czartery';
export const API_TRAVEL_AUTOCOMPLETE = '/api/travel/autocomplete'
